<label [attr.id]="id"
  [attr.for]="for"
  [attr.aria-disabled]="disabled"
  [ngClass]="{'disabled': disabled}">
  {{ value }}
  <span *ngIf="required"
    class="asterisk">*</span>
</label>